import { CASE_STATUS } from "./status.config"

export const RECORDS_STATUS = [
  CASE_STATUS.COMPLETE_PATIENT_RECORDS,
  CASE_STATUS.FILL_OUT_RX_FORM,
  CASE_STATUS.SUBMIT_TO_UASSIST,
  CASE_STATUS.REJECTED,

]

export const TABLE_VIEW_STATUS = [
  CASE_STATUS.REVIEW_PLAN,
  CASE_STATUS.MODIFICATION_REQUESTED,
  CASE_STATUS.REVIEW_MODIFICATION,
  CASE_STATUS.PLACE_ORDER,
  CASE_STATUS.IN_PRODUCTION,
  CASE_STATUS.SHIPPED,
  CASE_STATUS.DELIVERED,
  CASE_STATUS.ORDER_SUBMITTED,
  CASE_STATUS.TREATMENT_IN_PROGRESS,
  CASE_STATUS.TREATMENT_COMPLETE,
  CASE_STATUS.ARCHIVED,
  CASE_STATUS.CANCELLED,
  CASE_STATUS.ATTENTION_NEEDED,
  CASE_STATUS.SUBMITTED_TO_UASSIST,
  CASE_STATUS.PLANNING_IN_PROGRESS,
  CASE_STATUS.FROM_UDESIGN,
  CASE_STATUS.MODIFICATION_IN_PROGRESS,
  CASE_STATUS.DEFAULT,
  CASE_STATUS.UNLOCKED_FOR_PRINTING,
  CASE_STATUS.IN_OFFICE_PRINT
]

export const UASSIST_PROGRESS_STATUS = [
  CASE_STATUS.SHIPPED,
  CASE_STATUS.DELIVERED,
  CASE_STATUS.TREATMENT_IN_PROGRESS,
  CASE_STATUS.TREATMENT_COMPLETE,
  CASE_STATUS.FROM_UDESIGN,
]

const commonActions = {
  placeOrder: {
    btnText: "Place Order",
    btnAction: "OPEN_TREAT_PAGE",
    sxProps: {
      width: 273,
    },
  },
  downloadFiles: {
    btnText: "Download Case Files",
    btnAction: "DOWNLOAD_FILES",
    sxProps: {
      width: 273,
    },
  },
  archive: {
    btnText: "Archive Case",
    btnAction: "OPEN_CASE_ARCHIVE_MODEL",
    sxProps: {
      width: 273,
    },
  },
  cancel: {
    btnText: "Cancel",
    btnAction: "OPEN_CANCEL_MODEL",
    sxProps: {
      width: 273,
    },
  },
}
const unlockMenu = {
  btnText: "Unlock Case",
  btnAction: "UNLOCK_CASE",
  sxProps: {
    width: 273,
  },
}

const assignWorkflow = {
  btnText: "Change Office Workflow",
  btnAction: "CHANGE_WORKFLOW",
  sxProps: {
    width: 273,
  },
}

const actonButtonByStatus = [
  {
    status: CASE_STATUS.COMPLETE_PATIENT_RECORDS,
    bottomCaption: {
      textContent: (date: string) => `Last Updated ${date}`,
    },
    actions: [
      {
        btnText: "Complete Patient Records",
        btnAction: "OPEN_RECORDS",
        variant: "contained",
        sxProps: {
          width: 268,
        },
      },
      {
        btnText: "Archive Patient",
        btnAction: "OPEN_ARCHIVE_PATIENT_MODEL",
        variant: "outlined",
        sxProps: {
          width: 268,
        },
      },
      commonActions.archive
    ],
  },
  {
    status: CASE_STATUS.FILL_OUT_RX_FORM,
    bottomCaption: {
      textContent: (date: string) => `Last Updated ${date}`,
    },
    actions: [
      {
        btnText: "Open Prescription Form",
        btnAction: "OPEN_PRESCRIPTION_FORM",
        variant: "contained",
        sxProps: {
          minWidth: 248,
          width: "auto",
          maxWidth: "100%",
        },
      },
      {
        btnText: "Archive Patient",
        btnAction: "OPEN_ARCHIVE_PATIENT_MODEL",
        variant: "outlined",
        sxProps: {
          width: 248,
        },
      },
      commonActions.archive
    ],
  },
  {
    status: CASE_STATUS.SUBMIT_TO_UASSIST,
    bottomCaption: {
      textContent: (date: string) => `Last Updated ${date}`,
    },
    actions: [
      {
        btnText: "Submit to uAssist",
        btnAction: "OPEN_SUMMARY",
        variant: "contained",
        sxProps: {
          minWidth: 195,
          width: "auto",
          maxWidth: "100%",
        },
      },
      {
        btnText: "Archive Patient",
        btnAction: "OPEN_ARCHIVE_PATIENT_MODEL",
        variant: "outlined",
        sxProps: {
          width: 195,
        },
      },
      commonActions.archive
    ],
  },
  {
    status: CASE_STATUS.SUBMITTED_TO_UASSIST,
    topCaption: {
      textContent: "Perfect smiles coming soon",
    },
    bottomCaption: {
      textContent: (date: string) => `Submitted ${date}`,
    },
    actions: [
      //TODO: Enable in the future
      // {
      //   btnText: "Modify Patient Records",
      //   btnAction: "OPEN_RECORDS",
      //   variant: "outlined",
      //   sxProps: {
      //     width: 273,
      //   },
      // },
      // {
      //   btnText: "Modify uAssist Forms",
      //   btnAction: "OPEN_PRESCRIPTION_FORM",
      //   variant: "outlined",
      //   sxProps: {
      //     width: 273,
      //   },
      // },
      // {
      //   btnText: "Cancel uAssist Submission",
      //   btnAction: "OPEN_CANCEL_MODEL",
      //   variant: "outlined",
      //   sxProps: {
      //     width: 273,
      //   },
      // },
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
    ],
  },
  {
    status: CASE_STATUS.ATTENTION_NEEDED,
    topCaption: {
      textContent: "Perfect smiles coming soon",
    },
    bottomCaption: {
      textContent: (date: string) => `Submitted ${date}`,
    },
    actions: [
      {
        btnText: "Cancel uAssist Submission",
        btnAction: "OPEN_CANCEL_MODEL",
        variant: "outlined",
        sxProps: {
          width: 273,
        },
      },
      // {
      //   btnText: "Cancel",
      //   btnAction: "OPEN_CANCEL_MODEL",
      //   sxProps: {
      //     width: 273,
      //   },
      // },
    ],
  },
  {
    status: CASE_STATUS.PLANNING_IN_PROGRESS,
    topCaption: {
      textContent: "Perfect smiles coming soon",
    },
    bottomCaption: {
      textContent: (date: string) => `Submitted ${date}`,
    },
    actions: [
      // {
      //   btnText: "Cancel uAssist Submission",
      //   btnAction: "OPEN_CANCEL_MODEL",
      //   variant: "outlined",
      //   sxProps: {
      //     width: 273,
      //   },
      // },
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
    ],
  },
  {
    status: CASE_STATUS.MODIFICATION_IN_PROGRESS,
    topCaption: {
      textContent: "Perfect smiles coming soon",
    },
    bottomCaption: {
      textContent: (date: string) => `Submitted ${date}`,
    },
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
    ],
  },
  {
    status: CASE_STATUS.REVIEW_PLAN,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
      commonActions.archive,
    ],
  },
  {
    status: CASE_STATUS.MODIFICATION_REQUESTED,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
    ],
  },
  {
    status: CASE_STATUS.REVIEW_MODIFICATION,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
      commonActions.archive,
    ],
  },
  {
    status: CASE_STATUS.PLACE_ORDER,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
      commonActions.archive,
    ],
  },
  {
    status: CASE_STATUS.ORDER_SUBMITTED,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
    ],
  },
  {
    status: CASE_STATUS.IN_PRODUCTION,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
    ],
  },
  {
    status: CASE_STATUS.SHIPPED,
    actions: [
      {
        btnText: "Change Status to Treatment In Progress",
        btnAction: "UPDATE_STATUS_DELIVERED_TO_IN_PROGRESS",
        sxProps: {
          width: 273,
        },
      },
      commonActions.placeOrder,
      commonActions.downloadFiles,
      commonActions.archive,
    ],
  },
  {
    status: CASE_STATUS.IN_OFFICE_PRINT,
    actions: [
      {
        btnText: "Change Status to Treatment In Progress",
        btnAction: "UPDATE_STATUS_DELIVERED_TO_IN_PROGRESS",
        sxProps: {
          width: 273,
        },
      },
      commonActions.placeOrder,
      commonActions.downloadFiles,
      commonActions.archive,
    ],
  },
  {
    status: CASE_STATUS.DELIVERED,
    actions: [
      {
        btnText: "Change Status to Treatment In Progress",
        btnAction: "UPDATE_STATUS_DELIVERED_TO_IN_PROGRESS",
        sxProps: {
          width: 273,
        },
      },
      // {
      //   btnText: "Start Refinement",
      //   btnAction: "START_REFINEMENT",
      //   sxProps: {
      //     width: 273,
      //   },
      // },
      commonActions.placeOrder,
      commonActions.downloadFiles,
      commonActions.archive,
    ],
  },
  {
    status: CASE_STATUS.TREATMENT_IN_PROGRESS,
    actions: [
      {
        btnText: "Change Status to Treatment Complete",
        btnAction: "UPDATE_STATUS_IN_PROGRESS_TO_COMPLETE",
        sxProps: {
          width: 273,
        },
      },
      // {
      //   btnText: "Start Course Refinement",
      //   btnAction: "START_REFINEMENT",
      //   sxProps: {
      //     width: 273,
      //   },
      // },
      //TODO : we can enable in the future
      commonActions.placeOrder,
      commonActions.archive,
      commonActions.downloadFiles,
    ],
  },
  {
    status: CASE_STATUS.TREATMENT_COMPLETE,
    actions: [
      commonActions.placeOrder,
      commonActions.archive,
      commonActions.downloadFiles,
    ],
  },
  {
    status: CASE_STATUS.ARCHIVED,
    actions: [
      {
        btnText: "Unarchive Case",
        btnAction: "OPEN_CASE_UNARCHIVE_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
    ],
  },
  {
    status: CASE_STATUS.CANCELLED,
    actions: [
      {
        btnText: "Archive",
        btnAction: "OPEN_ARCHIVE_PATIENT_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
      commonActions.archive,
    ],
  },
  {
    status: CASE_STATUS.DEFAULT,
    bottomCaption: {
      textContent: (date: string) => `Last Updated ${date}`,
    },
    actions: [
      {
        btnText: "Archive Patient",
        btnAction: "OPEN_ARCHIVE_PATIENT_MODEL",
        variant: "outlined",
        sxProps: {
          width: 268,
        },
      },
    ],
  },
  {
    status: CASE_STATUS.SUBMITTED_TO_UASSIST_REFINEMENT,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
    ],
  },
  {
    status: CASE_STATUS.PLANNING_IN_PROGRESS_REFINEMENT,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
    ],
  },
  {
    status: CASE_STATUS.ATTENTION_NEEDED_REFINEMENT,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
    ],
  },
  {
    status: CASE_STATUS.FROM_UDESIGN,
    actions: [
      {
        btnText: "Cancel",
        btnAction: "OPEN_CANCEL_MODEL",
        sxProps: {
          width: 273,
        },
      },
      commonActions.downloadFiles,
      commonActions.archive,
    ],
  },
  {
    status: CASE_STATUS.REJECTED,
    actions: [
      {
        btnText: "Archive Case",
        btnAction: "OPEN_CASE_ARCHIVE_MODEL",
        variant: "outlined",
        sxProps: {
          border: "1px solid rgba(33, 150, 243, 0.50)",
          marginTop: 2,
          fontSize: "15px",
          lineHeight: "173.333%",
          letterSpacing: "0.46px",
          color: "primary.main",
        },
      },
    ],
  },
]

export const getRefinementMenu = (
  status: string,
  isInitialuAssist: boolean,
  isRefinementReady: boolean,
) => {
  const menus = []
  if (status === CASE_STATUS.DELIVERED || status === CASE_STATUS.SHIPPED) {
    menus.push({
      btnText: "Change Status to Treatment In Progress",
      btnAction: "UPDATE_STATUS_DELIVERED_TO_IN_PROGRESS",
      sxProps: {
        width: 273,
      },
    })
  }

  if (status === CASE_STATUS.TREATMENT_IN_PROGRESS) {
    menus.push({
      btnText: "Change Status to Treatment Complete",
      btnAction: "UPDATE_STATUS_IN_PROGRESS_TO_COMPLETE",
      sxProps: {
        width: 273,
      },
    })
  }

  // if (isInitialuAssist) {
  //   menus.push({
  //     btnText: "Start Initial uAssist",
  //     btnAction: "OPEN_RECORDS",
  //     sxProps: {
  //       width: 268,
  //     },
  //   })
  // }
  // if (isRefinementReady) {
  //   menus.push({
  //     btnText: "Start Course Refinement",
  //     btnAction: "START_REFINEMENT",
  //     sxProps: {
  //       width: 273,
  //     },
  //   })
  // }

  // TODO : we can enable in the future
  menus.push({
    btnText: "Place Order",
    btnAction: "OPEN_TREAT_PAGE",
    sxProps: {
      width: 273,
    },
  })

  menus.push({
    btnText: "Archive Case",
    btnAction: "OPEN_CASE_ARCHIVE_MODEL",
    sxProps: {
      width: 273,
    },
  })

  menus.push({
    btnText: "Download Case Files",
    btnAction: "DOWNLOAD_FILES",
    sxProps: {
      width: 273,
    },
  })

  return { actions: menus }
}

export const UNARCHIVEPATIENT = {
  btnText: "Unarchive Patient",
  btnAction: "OPEN_UNARCHIVE_PATIENT_MODEL",
  variant: "shade",
  sxProps: {
    width: 116,
  },
}

export const ARCHIVEPATIENT = {
  btnText: "Archive",
  btnAction: "OPEN_ARCHIVE_PATIENT_MODEL",
  variant: "shade",
  sxProps: {
    width: 95,
  },
}

/**
 * Modifies the button text based on status and refinement conditions
 * @param actionsByStatus - The current actions configuration
 * @param status - Current case status
 * @param isRefinementReady - Whether case is ready for refinement
 * @returns Modified actions configuration or original if no modifications needed
 */
const modifyActionButtonText = (
  actionsByStatus: typeof actonButtonByStatus[0] | undefined,
  status: string,
  isRefinementReady: boolean
) => {
  if (!actionsByStatus) return actionsByStatus;

  let modifiedActions = { ...actionsByStatus };

  // Modify button text based on status and refinement state
  if (status === CASE_STATUS.FILL_OUT_RX_FORM && isRefinementReady) {
    modifiedActions = {
      ...modifiedActions,
      actions: modifiedActions.actions.map(action =>
        action.btnAction === "OPEN_PRESCRIPTION_FORM"
          ? { ...action, btnText: "Open Refinement Prescription Form" }
          : action
      )
    };
  }

  if (status === CASE_STATUS.SUBMIT_TO_UASSIST && isRefinementReady) {
    modifiedActions = {
      ...modifiedActions,
      actions: modifiedActions.actions.map(action =>
        action.btnAction === "OPEN_SUMMARY"
          ? { ...action, btnText: "Submit Refinement to uAssist" }
          : action
      )
    };
  }

  return modifiedActions;
};

export const getBtnActionsByStatus = (
  status: string,
  isInitialuAssist = false,
  isRefinementReady = false,
  haveUnlockAccess = false,
  showWorkflow
) => {
  let unlockMenuAction = (haveUnlockAccess && showUnlockBtn(status)) ? [unlockMenu] : [];

  showWorkflow && (unlockMenuAction.push(assignWorkflow))

  // Refinement menu case
  if (UASSIST_PROGRESS_STATUS.includes(status) && (isInitialuAssist || isRefinementReady)) {
    const refinementMenu = getRefinementMenu(status, isInitialuAssist, isRefinementReady)
    return {
      ...refinementMenu,
      actions: [...refinementMenu.actions, ...unlockMenuAction],
    };
  }

  // Find actions by status
  let actionsByStatus = status ? actonButtonByStatus.find((obj) => obj.status === status) : undefined
  const defaultActions = actonButtonByStatus.find((obj) => obj.status === CASE_STATUS.DEFAULT)

  actionsByStatus = modifyActionButtonText(actionsByStatus, status, isRefinementReady);

  if (actionsByStatus) {
    return {
      ...actionsByStatus,
      actions: [...actionsByStatus.actions, ...unlockMenuAction],
    };
  }

  // Fallback to default actions
  if (defaultActions) {
    return {
      ...defaultActions,
      actions: [...defaultActions.actions, ...unlockMenuAction],
    }
  }

  // If no actions found, return empty actions
  return { actions: unlockMenuAction }
}

const showUnlockBtn = (caseDisposition: string) => {
  const lockedStatuses = [
    "PLANNING_IN_PROGRESS",
    "ATTENTION_NEEDED",
    "MODIFICATION_IN_PROGRESS",
    "ORDER_SUBMITTED",
    "IN_PRODUCTION",
  ];
  return !lockedStatuses.includes(caseDisposition)
}